import { FC } from "react";
import { PageHeader } from "./PageHeader";
import { Paragraph } from "../Paragraph";
import { Button } from "../form/Button";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export const NotFound: FC = () => {
  const navigate = useNavigate()

  return <div>
    <PageHeader>Not found</PageHeader>
    <Paragraph>
      This page either does not exist, or you do not have permission to view it.
    </Paragraph>
    <Button type={"primary"} size={"sm"} text={"Go back"} icon={faChevronCircleLeft} onClick={() => navigate(-1)} />
  </div>
}
